exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.v--modal-overlay .v--modal-box.carryout-modal {\n  position: static !important;\n}\n", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/popup/ModalCarryout.vue"],"names":[],"mappings":";AACA;EACE,4BAA4B;CAC7B","file":"ModalCarryout.vue","sourcesContent":["\n.v--modal-overlay .v--modal-box.carryout-modal {\n  position: static !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d9fb159","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/ModalCarryout.vue
// module id = 6PkQ
// module chunks = 0 78 79 80 81